/* eslint-disable @typescript-eslint/ban-ts-comment */
import { safeJSONParse } from '@shared/utils'
import { API, apiEnv, SSOconfig, TApiEnv, PACKAGE_NAME, APP_NAME, isSeparateAccount } from '@remote/api/config'
import { getPubKeySign } from '@remote/api/get-pub-key-sign'
import global from '@remote/store/constantStore'
import { joinParams, parseSearch, popLocalValue, parseTime } from '@remote/utils'
import { Captcha } from '@xbase/captcha'
import { isAndroidNative as isAndroid, sendMessage, isIOSNative as isIOS } from '@xunlei/universal-native-api'
import { isHeziNative, isAndroidHezi, isIOSHezi } from '@remote/utils/platform'
import hzAndroidBridge from '@remote/utils/jsbridge/hezi/android'
import { IOptions, IParams, Method } from '../type'
import pkg from '../../package.json'
import { ERROR_DESC_MAP, SUPPORT_REQUEST_CODE } from '@remote/constant'
import sso from '@remote/utils/sso'
import router from '../router'
// 接口文档:
// https://md.office.k8s.xunlei.cn/eOm77z-pSOu80y8YHvyXvA
// http://drive.office.k8s.xunlei.cn/?urls.primaryName=file.swagger.json

export async function request (
  url: string,
  params: IParams = {},
  options: (IOptions & { apiEnv?: TApiEnv }) = {},
): Promise<any> {
  const urlHost = API[options.apiEnv || apiEnv]
  url = url.includes('http') ? url : urlHost + url
  const method: Method = options.method || 'GET'
  if (method === 'GET') {
    url = joinParams(url, params)
  }
  const connectTime = parseTime(new Date())
  if (isAndroid) {
    console.log('android :>> ', 'url:', url, 'params', params)
    // 盒子接口头部需要添加target字段
    let headers = {}
    // if (options?.headers?.['Target'] && url.includes('api-hezi.xunlei.com')) headers['Target'] = options?.headers?.['Target']
    if (options?.headers?.['Target'] && url.includes('api-hezi.xunlei.com')) headers = Object.assign({}, headers, options?.headers)
    // TODO: 新版手雷 (唉，判断越来越多了)
    if (global.versionCode && global.versionCode >= SUPPORT_REQUEST_CODE) {
      const res = await sendMessage({
        platform: 'android',
        name: 'xlAjax',
        params: {
          url,
          method,
          body: method === 'GET' ? undefined : params,
          header: headers,
        },
      }, { callbackTimeout: 10000 })
      if (res) {
        popLocalValue('connectMessage', {
          [url]: res,
          connectTime,
        })
        if (res.ret === 0) {
          return [null, JSON.parse(res.body)]
        } else {
          return [safeJSONParse(res.body), null]
        }
      } else {
        popLocalValue('connectMessage', {
          [url]: { error_description: 'unknown' },
          connectTime,
        })
        return [{ error_description: 'unknown' }, null]
      }
    } else {
      const res = await sendMessage({
        platform: 'android',
        name: 'xlHttpRequestForward2',
        params: {
          url,
          method,
          body: method === 'GET' ? undefined : params,
        },
      }, { callbackTimeout: 10000 })
      if (res && res.error) {
        popLocalValue('connectMessage', {
          [url]: res.error,
          connectTime,
        })
        return [res, null]
      } else {
        popLocalValue('connectMessage', {
          [url]: res,
          connectTime,
        })
        return [null, res]
      }
    }
  }
  // TODO: 当前IOS手雷的xlAjax针对delete请求path不允许带?参数
  if (isIOS && global.iosRequest) {
    const parseURL = new URL(url)
    const iosRequestParams: any = {
      method,
      host: parseURL.origin,
      path: parseURL.pathname,
      jsonRequest: 2,
    }
    if (params && Object.keys(params).length > 0) {
      iosRequestParams.params = params
    }

    if (method !== 'GET') {
      // json 参数请求必须传 1
      iosRequestParams.jsonRequest = 1
      if (method === 'DELETE') {
        iosRequestParams.jsonRequest = 0
        iosRequestParams.params = parseSearch(parseURL.search)
      }
    }
    let headers = {}
    if (options.headers?.['Target'] && url.includes('api-hezi.xunlei.com')) headers = Object.assign({}, headers, options?.headers)
    if (isSeparateAccount && url.includes('api-hezi.xunlei.com')) {
      headers['X-Reg-From'] = 'xbase'
    }
    iosRequestParams.headers = {
      'x-client-id': SSOconfig.clientId,
      ...headers,
    }
    // console.log('iosRequestParams :>> ', iosRequestParams)
    const [err, res] = await sendMessage({ platform: 'ios', name: 'xlAjax', params: iosRequestParams }, { callbackTimeout: 1000 * 10 })
    // console.log('[iOS.xlAjax]', iosRequestParams, err, res)
    if (err === null && res && res.result === 0) {
      try {
        const data = JSON.parse(res.data)
        console.log('ios result', data)
        popLocalValue('connectMessage', {
          [url]: data,
          connectTime,
        })
        if (data.error) {
          return [data, null]
        }
        return [null, data]
      } catch (err) {
        console.error(err)
      }
    }
  }
  // 迅雷盒子Android客户端
  if (isAndroidHezi) {
    const response = await new Promise((resolve, reject) => {
      hzAndroidBridge.request({
        url,
        method: method as 'GET' | 'POST',
        data: method === 'GET' ? null : JSON.stringify(params),
      }, (error, result) => {
        if (error) {
          resolve([error, null])
        } else {
          resolve([null, result])
        }
      })
      setTimeout(() => {
        reject(new Error('请求超时'))
      }, 10 * 1000)
    })
    return response
  }
  if (!isAndroid) {
    const { deviceId, userId, userName } = global.device || {deviceId: ''}
    if (!isHeziNative && !global.device) {
      router.push({
        path: '/home',
      })
    }
    const captchaInstance = new Captcha({
      apiOrigins: SSOconfig.apiOrigins,
      clientId: SSOconfig.clientId,
      originDeviceId: deviceId,
      baseRequest: isIOS ? null : sso.request.bind(sso) as any,
    })
    // 不支持并发请求,若是简单请求直接获取默认action的captcha_token

    let headers = {
      'x-device-id': deviceId,
      'x-client-id': SSOconfig.clientId,
      'content-type': 'application/json',
    }
    // 盒子接口头部需要添加target字段
    // if (options?.headers?.['Target'] && url.includes('api-hezi.xunlei.com')) headers['Target'] = options?.headers?.['Target']
    if (options?.headers?.['Target'] && url.includes('api-hezi.xunlei.com')) headers = Object.assign({}, headers, options?.headers)

    if (isIOS) {
      const [err, res] = await sendMessage({
        platform: 'ios',
        name: 'userInfo',
      }, { callbackTimeout: 1000 * 10 })
      if (err) {
        popLocalValue('connectMessage', {
          [url]: err,
          connectTime,
        })
        return [err, null]
      } else {
        const Authorize = 'Bearer ' + res.authorize
        headers['Authorization'] = Authorize
      }
    }
    const extdata: any = {}
    const timestamp = String(Date.now())
    const withCaptchaMeta = {
      user_id: userId + '',
      user_name: userName,
      client_version: pkg.version,
      package_name: PACKAGE_NAME,
      timestamp,
      // captcha_sign: sign,
    }
    // console.log('PACKAGE_NAME', APP_NAME)
    if (!isSeparateAccount) {
      const sign = await getPubKeySign({ timestamp, deviceId })
      // @ts-ignore
      withCaptchaMeta.captcha_sign = sign
    } else {
      if (url.includes('api-hezi.xunlei.com')) headers['X-Reg-From'] = 'xbase'
    }
    

    let action = 'GET:CAPTCHA_TOKEN'
    const getCaptchaTokenResp = await captchaInstance.getCaptchaToken(action, withCaptchaMeta, false)
    headers['x-captcha-token'] = getCaptchaTokenResp
    if (method !== 'GET') {
      action = ''
      extdata.body = JSON.stringify(params)
    }
    const opts = {
      method,
      headers,
      captchaAction: action,
      withCaptchaMeta,
      ...extdata,
    }
    if (!isAndroid && !isIOS) {
      opts['withCredentials'] = true
    }
    try {
      const result = await captchaInstance.request(url, opts)
      popLocalValue('connectMessage', {
        [url]: result,
        connectTime,
      })
      return [null, result]
    } catch (err) {
      popLocalValue('connectMessage', {
        [url]: err,
        connectTime,
      })
      console.log('request error', url, err)
      return [{
        ...err,
        error_description: (ERROR_DESC_MAP[err.error] || err.error_description),
      }, null]
    }
  }
}
